import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Bearer fallback for iframe/cross-origin contexts where httpOnly cookies
// may be blocked. Stored in sessionStorage (cleared on tab close, per-tab
// isolated) rather than localStorage to shrink XSS impact.
const TOKEN_KEY = "poh_access_token";

export function setBearer(token) {
  try {
    if (token) sessionStorage.setItem(TOKEN_KEY, token);
    else sessionStorage.removeItem(TOKEN_KEY);
  } catch (err) {
    // sessionStorage may be blocked in private mode — cookies remain primary.
    if (process.env.NODE_ENV !== "production") console.debug("[api] setBearer skipped:", err?.message);
  }
}

export function getBearer() {
  try {
    return sessionStorage.getItem(TOKEN_KEY);
  } catch (err) {
    if (process.env.NODE_ENV !== "production") console.debug("[api] getBearer skipped:", err?.message);
    return null;
  }
}

api.interceptors.request.use((cfg) => {
  const tok = getBearer();
  if (tok && !cfg.headers?.Authorization) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${tok}`;
  }
  return cfg;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
